import { Injectable }    from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import * as ApiConfig from '../core/apiconfig';
import * as CitizenModel from './index.model'

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class RegisterService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = ApiConfig.API_URL;
    }

    // Post the Register Form Data to Api
    RegisterInsert(model: CitizenModel.CitizenInfoBase) {

        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(this.apiUrl + ApiConfig.API_Citizen, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/citizen/register.service.ts